import { RubiksCube } from "@/components/RubiksCube";
import { BuenosAiresData } from "@/components/BuenosAiresData";

const Index = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 grid grid-cols-1 lg:grid-cols-2">
    {/* 3D Cube Scene */}
    <div className="relative min-h-screen lg:min-h-auto">
      <RubiksCube />
      <div className="absolute top-4 left-4 z-10">
        <h1 className="text-3xl font-bold text-white drop-shadow-lg">
          Buenos Aires Explorer
        </h1>
        <p className="text-slate-300 mt-1">Interactive 3D Experience</p>
      </div>
    </div>

    {/* Data Panel */}
    <div className="p-8 lg:p-12 flex flex-col justify-center">
      <BuenosAiresData />
    </div>
  </div>
);

export default Index;